module.exports = __webpack_public_path__ + "static/ds-1-LG-e5fbf3483b9b396e52db992955955093.jpg";